
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { ProcessSection } from './components/ProcessSection';
import { WhyChooseSection } from './components/WhyChooseSection';
import { CalculatorSection } from './components/CalculatorSection';
import { ContactSection } from './components/ContactSection';
import { CredibilitySection } from './components/CredibilitySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ServiceAreaSection } from './components/ServiceAreaSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ServicesSection />
      <ProcessSection />
      <WhyChooseSection />
      <CalculatorSection />
      <ContactSection />
      <CredibilitySection />
      <TestimonialsSection />
      <FAQSection />
      <ServiceAreaSection />
      <Footer />
    </div>
  );
}
